import { t } from "@local-logic/core/localization";

export const walking = t("Walking", {
  _key: "walking",
  _context: "The text that appears in the commute calculator dropdown",
  _tags: "local_content_sdk",
  _charlimit: 20,
});

export const driving = t("Driving", {
  _key: "driving",
  _context: "The text that appears in the commute calculator dropdown",
  _tags: "local_content_sdk",
  _charlimit: 20,
});

export const minute = t("Minute", {
  _key: "minute",
  _context: "The text that appears in the commute calculator for duration",
  _tags: "local_content_sdk",
  _charlimit: 20,
});

export const hour = t("Hour", {
  _key: "hour",
  _context: "The text that appears in the commute calculator for duration",
  _tags: "local_content_sdk",
  _charlimit: 20,
});

export const yards = t("yd", {
  _key: "yard",
  _context:
    "The text that appears in the commute calculator for distance if imperial units are selected",
  _tags: "local_content_sdk",
  _charlimit: 20,
});

export const miles = t("mi", {
  _key: "miles",
  _context:
    "The text that appears in the commute calculator for distance if imperial units are selected",
  _tags: "local_content_sdk",
  _charlimit: 20,
});

export const meters = t("m", {
  _key: "meters",
  _context:
    "The text that appears in the commute calculator for distance if metric units are selected",
  _tags: "local_content_sdk",
  _charlimit: 20,
});

export const kilometers = t("km", {
  _key: "kilometers",
  _context:
    "The text that appears in the commute calculator for distance if metric units are selected",
  _tags: "local_content_sdk",
  _charlimit: 20,
});

export const fastestRoute = t("Fastest Route", {
  _key: "fastestRoute",
  _context:
    "The text that appears in the commute calculator when route is found",
  _tags: "local_content_sdk",
  _charlimit: 20,
});

export const noRoute = t("No route available", {
  _key: "noRoute",
  _context:
    "The text that appears in the commute calculator when no route is found",
  _tags: "local_content_sdk",
  _charlimit: 20,
});

export const trySuggestion = t("Try another query.", {
  _key: "trySuggestion",
  _context:
    "The text that appears in the commute calculator when no route is found",
  _tags: "local_content_sdk",
});

export const calculateCommute = t("Calculate commute", {
  _key: "calculateCommute",
  _context: "The text that appears in the commute calculator search label",
  _tags: "local_content_sdk",
});

export const searchMap = t("Search map...", {
  _key: "searchMap",
  _context:
    "The text that appears in the commute calculator search placeholder",
  _tags: "local_content_sdk",
});
